var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 100,
    viewBox: "0 0 124 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 123.684,
    height: 100,
    rx: 12,
    fill: "#D2EFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0H111.684C118.312 0 123.684 5.37258 123.684 12V88C123.684 94.6274 118.312 100 111.684 100H12C5.37257 100 0 94.6274 0 88V12Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 86.842L63.1579 36.842L123.684 86.842V87.9999C123.684 94.6274 118.312 99.9999 111.684 99.9999H12C5.37257 99.9999 0 94.6274 0 87.9999V86.842Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.684 10.5264L67.218 64.5376C64.9338 66.7224 61.3463 66.7605 59.0163 64.6246L0 10.5264L123.684 10.5264Z",
    fill: "#031D43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.5263C0 4.71279 4.71279 0 10.5263 0H113.158C118.971 0 123.684 4.71279 123.684 10.5263V10.5263L66.8989 57.4359C64.717 59.2383 61.5723 59.2711 59.3534 57.5144L0 10.5263V10.5263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f31a84d19c3d1888ee3c91b2e2ff6749.svg";
export { ForwardRef as ReactComponent };